import { render, staticRenderFns } from "./leftbar-list.vue?vue&type=template&id=612aa82e&"
import script from "./leftbar-list.vue?vue&type=script&lang=js&"
export * from "./leftbar-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports